{
  "es": {
    "overview": {
      "actions": {
        "select_decision": "Seleccionar decisión",
        "select_installment": "Seleccionar cuota",
        "select_point_list": "Seleccionar lista de incidencias",
        "select_survey": "Seleccionar encuesta"
      },
      "table": {
        "labels": {
          "category": "Categoría",
          "level": "Nivel",
          "project": "Proyecto",
          "status": "Estado",
          "unit": "Unidad"
        }
      }
    }
  }
}
